import React from 'react';
import PropTypes from 'prop-types';

const PausePath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M20 4a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-7zM5 4a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5z"
    />
  );
};

PausePath.propTypes = {
  fill: PropTypes.string,
};

export default PausePath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/pause.jsx